import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/blocks/cookie-consent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hotjar-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/.pnpm/next-auth@5.0.0-beta.25_next@15.3.8_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19._b5cb2487da04602a6c082859ef534873/node_modules/next-auth/react.js");
